import React, { useContext, useMemo } from "react"

import Breadcrumb from "@/components/breadCrumb";
import companyProfileHeaderLogo from "@/resources/original/company-profile-header-logo.svg";
import { AppContext, ContextType } from "@/shared/context";
import { useTranslation } from "react-i18next";
import { DunsMgrClaimCtaComponent } from "@/components/DunsMgrClaimCta/DunsMgrClaimCta";
// import { checkSupression } from "@/utils";

const TopBanner = ({props, breadcrumb}): JSX.Element => {
  const { isUnitedStates, isEuBd } = useContext(AppContext) as ContextType;
  const {t} = useTranslation();

  const staticBreadcrumbs = [
    {
      name: t("homeLabel"),
      url: t("homeRedirection"),
      useAnchorTag: true
    },
    {
      name: t("business_directory"),
      url: t("bdLandingPageRedirectionLink")
  }]
  
  let breadcrumbs = useMemo(() => {
    const recievedBreadcrumbs = breadcrumb.map(((bc, i) => ({
      name: bc?.name,
      url: bc?.url || '',
      style: i === breadcrumb.length - 1 ? "text-capitalize" : ""
    })))

    return [...staticBreadcrumbs, ...recievedBreadcrumbs]
  }, [breadcrumb])

  return (
    <>
    {/* <button className="btn i18Button" onClick={()=>changeLanguage('de')}>DE</button>
    <button className="btn i18Button" onClick={()=>changeLanguage('en')}>EN</button> */}
      <div className="business-directory-redesign-container company-profile-header-container">
        <img
          className="company-profile-header-logo d-print-none"
          src={companyProfileHeaderLogo}
          alt="headerLogo"
        />
        {t("companyProfile.heading.headingText")}
      </div>
      <div className="business-directory-redesign-container company-profile-main-header">
        <div className="row company-profile-breadcrumb px-0">
          <Breadcrumb
            breadcrumbs={breadcrumbs}
            forComponent="companyProfile"
            styling="font-style-roman"
          />
        </div>
        <div className="row company-profile-main-row">
          <div className="col-md-8">
            <div className="company-profile-header-title">
              {props.companyProfileHeaderTitle || "Company Header Title pvt. ltd."}
            </div>
            <input
              type="hidden"
              id="company-profile-company-info-json"
              name="companyInfoJson"
              value={props.companyInfoJson}
            />
            <div className="company-profile-rank">
              {isUnitedStates && props.companyProfileRankingValue && props.companyProfileRankingValue !== 0
              && props.companyProfileRankingDesc ? (
                <>
                  <span className="rank">
                    <span className="prefix">
                      
                    </span>
                    #{props.companyProfileRankingValue}
                    <span className="suffix">
                      
                    </span>
                  </span>
                  <span className="from-list">
                    &nbsp;{props.companyProfileRankingDesc}
                  </span>
                  <span className="lineSeparator d-print-none"> | </span>
                </>
              ): ''}

              {props.companyWebsiteUrl &&
                <a
                  className="ext-icon company-website-url company-website-url1 d-print-none "
                  aria-label={`Go to ${props.companyProfileHeaderTitle} website`}
                  href={props.companyWebsiteUrl?.startsWith('http') ? props.companyWebsiteUrl : `http://${props.companyWebsiteUrl}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {/* {props.dunsMgrClaimCtaData.properties.websiteLabel || "websiteLabel"}  */}
                  {t("companyProfile.heading.websiteLabel")}
                </a>
              }
            </div>
            <div className="company-profile-type-role">
              {/* {props.companyType &&
                <span
                  className="company-profile-comp role"
                  data-tracking-name="Legal Form"
                >
                  {checkSupression(props.companyType)}
                </span>
              } */}
              {/* {props.companyRole &&
                <span
                  className="company-profile-comp type"
                  data-tracking-name="Family Tree Member Role"
                >
                  {props.companyRole}
                </span>
              } */}
            </div>
          </div>
          <div className="col-md-4 text-right buttonBanner d-print-none">
            <div id="trial-claim-section">
              <div>
                <a
                  aria-label="DNB Hoovers Free Trial CTA"
                  className="dnbHooversFreeTrialCtaLink btn button-primary"
                  style={{ width: '90%' }}
                  href= {t("companyProfile.heading.dnbHooversFreeTrialBtnLink")}
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("companyProfile.heading.dnbHooversFreeTrialBtnText")}
                </a>
              </div>
              <div className="company-profile-claimed-status">
                <DunsMgrClaimCtaComponent
                  dunsMgrClaimCtaData={props.dunsMgrClaimCtaData!}
                  inAnchorsComponent={false} />
                {/* <sly data-sly-include="/apps/dnb/dnb-mod/company/company_profile_duns_mngr_experience/duns_mgr_claim_cta.jsp" /> */}
                {/* have to create and call this component here */}
              </div>
              {isEuBd && <div style={{ marginTop: "10px" }}>
                <a
                  className="button-white"
                  style={{ width: "90%" }}
                  href= {t("companyProfile.heading.viewSampleDataLink")}
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("companyProfile.heading.viewSampleLocalized")}
                </a>
              </div>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopBanner;
